export default function reflowChartsBeforePrint(Highcharts) {
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia("print");
    mediaQueryList.addEventListener("change", function (mql) {
      if (mql.matches) {
        Highcharts.charts.forEach((c) => {
          if (c) {
            c.reflow();
          }
        });
      }
    });
  }
}
